import React from 'react';
import { Modal as ModalComponent } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import moment from 'moment';
import { Container, Title, Center, RowContainer, Description, AlertsList, AlertItem, AlertMessage, AlertMeta, CloseButton } from './styles';
import { Warning } from 'src/assets/Images';
var TicketAlertsModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, alerts = _a.alerts, buildingName = _a.buildingName, apartmentNumber = _a.apartmentNumber;
    var isBuilding = !apartmentNumber;
    var title = isBuilding
        ? "Atenci\u00F3n, est\u00E1 por crear un ticket para el edificio: " + (buildingName || '')
        : "Atenci\u00F3n, est\u00E1 por crear un ticket para el apartamento n\u00B0: " + (apartmentNumber || '');
    var subtitle = isBuilding
        ? 'Este edificio tiene las siguientes alertas:'
        : 'Este apartamento tiene las siguientes alertas:';
    var handleClose = function (_event, reason) {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown')
            return;
        onClose();
    };
    var formatDate = function (dateString) {
        return moment(dateString).format('DD/MM/YYYY');
    };
    return (React.createElement(ModalComponent, { open: isOpen, onClose: handleClose },
        React.createElement(Center, null,
            React.createElement(Container, null,
                React.createElement(RowContainer, { className: "right close" },
                    React.createElement(Close, { onClick: onClose })),
                React.createElement(RowContainer, { className: "center" },
                    React.createElement("img", { src: Warning, alt: "Warning" })),
                React.createElement(Title, null, title),
                React.createElement(Description, null, subtitle),
                React.createElement(AlertsList, null, alerts.map(function (alert) { return (React.createElement(AlertItem, { key: alert.id },
                    React.createElement(AlertMessage, null, alert.message),
                    React.createElement(AlertMeta, null,
                        "Creado por ",
                        alert.created_by.first_name,
                        " ",
                        alert.created_by.last_name,
                        " el ",
                        formatDate(alert.created_at)))); })),
                React.createElement(RowContainer, { className: "center" },
                    React.createElement(CloseButton, { onClick: onClose }, "Cerrar"))))));
};
export default TicketAlertsModal;
